var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"grid max-w-xl grid-cols-3 px-6 py-3 mx-auto lg:p-6"},[_c('div',[_vm._t("back")],2),_c('div'),_c('div',[_vm._t("next")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }